import { View, type TextStyle, type ViewStyle } from 'react-native';
import { Button, Text, useTheme } from 'react-native-paper';

import { useTranslation } from '@/i18n';
import { spacing } from '@/theme';

interface StartupErrorStateProps {
  readonly onRetry: () => void;
  readonly isRetrying?: boolean;
  readonly testID?: string;
}

const containerStyle: ViewStyle = {
  flex: 1,
  alignItems: 'center',
  justifyContent: 'center',
  padding: spacing[6],
  gap: spacing[4],
};

const messageStyle: TextStyle = {
  textAlign: 'center',
};

export const StartupErrorState = ({
  onRetry,
  isRetrying = false,
  testID,
}: StartupErrorStateProps) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <View style={containerStyle} testID={testID}>
      <Text variant="titleMedium">{t('startup.connectionErrorTitle')}</Text>
      <Text style={[messageStyle, { color: theme.colors.onSurfaceVariant }]}>
        {t('startup.connectionErrorMessage')}
      </Text>
      <Button
        mode="contained"
        onPress={onRetry}
        disabled={isRetrying}
        loading={isRetrying}
        testID="startup-error-retry">
        {t('startup.retry')}
      </Button>
    </View>
  );
};
